export var _paragraphTheme = {
  baseStyle: () => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'xxs',
      width: '100%'
    },
    title: {},
    content: {}
  }),
  sizes: {
    large: {
      title: {
        textStyle: 'body2Semi'
      },
      content: {
        textStyle: 'body2'
      }
    },
    small: {
      title: {
        textStyle: 'body3Semi'
      },
      content: {
        textStyle: 'body3'
      }
    }
  },
  defaultProps: {
    size: 'small'
  }
};
//# sourceMappingURL=_Paragraph.theme.js.map